export default __webpack_public_path__ + "static/media/Circuits.a03897b9.svg";